import React from 'react'
import logoSrc from "../../static/svg/Explo.svg";
import { Skeleton } from "@mui/material";
import SvgMarquee from "./SvgMarquee";

function SvgPanel({ className, dataArray }) {
    const componentsMap = {
        text: "text",
        P10red: SvgMarquee,
    };
    return (
        <div className={`aspect-[4500/3600] relative ${className}`} >

            <svg viewBox="0 0 4500 3600" preserveAspectRatio="xMidYMid meet" className="w-full h-full bg-[#237F52]" >
                <rect x="70" y="70" width="4360" height="3460" fill="#237F52" stroke="#fff" strokeWidth="35" />
                {logoSrc && (
                    <image href={logoSrc} x="0" y="150" width="1400" preserveAspectRatio="xMidYMid meet" />
                )}

                {dataArray[1].state ? (
                    dataArray[0].map((item, index) => {
                        const Component = componentsMap[item.component];
                        return (
                            <Component
                                key={index}
                                x={item.left + "%"}
                                y={item.top + "%"}
                                fontWeight={item.fontWeight}
                                fontSize={item.fontSize}
                                transform={`scale(${item.scale || 1}, 1)`}
                                textAnchor={item.textAnchor}
                                fill={item.color}
                                width={item.width}
                                height={item.height}
                                weight={item.fontWeight}
                                text={item.text}
                            >
                                {item.text}
                            </Component>
                        );
                    })
                ) : (
                    dataArray[0].map((item, index) => {
                        return (
                            <foreignObject
                                key={index}
                                x={`${item.left}%`}
                                y={item.height ? `${item.top}%` : `${item.top - 4}%`}
                                transform={`scale(${item.scale || 1}, 1)`}
                                fill={item.color}
                                width={item.width || 400}
                                height={item.height || 50}
                            >
                                <Skeleton
                                    variant={item.component === "text" ? "text" : "rectangular"}
                                    sx={{
                                        width: "100%",
                                        height: "10rem",
                                        fontSize: '10rem',
                                        backgroundColor: "#094910",
                                    }}
                                />
                            </foreignObject>
                        );
                    })
                )
                }
            </svg>
        </div>
    )
}

export default SvgPanel